import {Component, OnInit} from '@angular/core';
import {UserSearch} from '@models/search';
import {SEARCH_PARAMS} from '@models/empty';
import {UserService} from '@services/user.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-new',
    template: '',
})
export class NewComponent implements OnInit {

    constructor(private userService: UserService, private router: Router) {
    }

    ngOnInit(): void {
        var currentSearch: UserSearch = ({} as UserSearch);
        currentSearch.search_ad_params = JSON.parse(JSON.stringify(SEARCH_PARAMS)); // clone : ne pas contaminer la constante partagée

        this.userService.setCurrentSearch(currentSearch);
        this.router.navigate(['/app/search/result']);
    }
}
